import React from 'react';

import SelectionContainer from 'components/selection-container';

interface IComboSlotsDetailsContainer {
  title: string;
  requirementSatisfied: boolean;
  required: boolean;
  children: React.ReactNode;
}

const ComboSlotsDetailsContainer: React.FC<IComboSlotsDetailsContainer> = ({
  children,
  ...otherProps
}) => (
  <SelectionContainer multiColumnLayout showCheckMarkOnRequirementSatisfied={false} {...otherProps}>
    {children}
  </SelectionContainer>
);

export default ComboSlotsDetailsContainer;
